import { render, staticRenderFns } from "./QtdBbAisBdgd.vue?vue&type=template&id=7b3af8c8&"
import script from "./QtdBbAisBdgd.vue?vue&type=script&lang=js&"
export * from "./QtdBbAisBdgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports